

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { AuthContextProvider } from "context";
import { LicenseInfo } from '@mui/x-license-pro';

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Set the Material-UI Pro License Key from environment variable
const licenseKey = process.env.REACT_APP_MUI_LICENSE_KEY || '';

// LicenseInfo.setLicenseKey('');

if (licenseKey) {
  LicenseInfo.setLicenseKey(licenseKey);
} else {
  console.warn('Material-UI Pro License Key is missing!');
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ? process.env.REACT_APP_GOOGLE_CLIENT_ID.trim() : ''}>
      <AuthContextProvider>
        <MaterialUIControllerProvider>
          <App />
        </MaterialUIControllerProvider>
      </AuthContextProvider>
    </GoogleOAuthProvider>
  </BrowserRouter>
);